var React = require('react');

function NemkontoSymbol (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24z","key":0}),React.createElement("path",{"d":"M9.96 24a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zM39 18.24a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm0 11.52a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm-4.08 5.76a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm0-23.04a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zM16.392 24a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm6.432 0a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm6.432 0a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm6.432 0a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0zm6.432 0a2.04 2.04 0 11-4.08 0 2.04 2.04 0 014.08 0z","key":1})]);
}

NemkontoSymbol.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = NemkontoSymbol;

NemkontoSymbol.default = NemkontoSymbol;
